import api from "./Urls";
import { generateToken } from "./firebase";

export const registerFcmTokenInBackground = (userId) => {
  const normalizedUserId = Number(userId);

  if (!Number.isFinite(normalizedUserId) || normalizedUserId <= 0) {
    return;
  }

  void (async () => {
    try {
      const fcmToken = await generateToken();

      if (!fcmToken) {
        return;
      }

      await api.post("/api/notifications/token", {
        userId: normalizedUserId,
        token: fcmToken,
      });

      console.log("FCM token saved");
    } catch (error) {
      // Browser push is optional and must never block login/signup.
      console.warn("FCM registration skipped", error);
    }
  })();
};
